'use client';
import { SeriesTitleProps } from '@repo/ui/src/components/SeriesTitleAndText';
import { ToutContent } from '@repo/ui/src/components/ToutContent/_toutContent';
import { ImageProps } from '../../types';

interface Props {
  columns: Array<SeriesTitleProps | ImageProps>;
}

const FlexContainer = ({ columns }: Props) => {
  if (!columns) return null;

  return (
    <section className="tw-bg-warm-100">
      <div className="tw-flex tw-bg-warm-100 tw-flex-col sm:tw-flex-row tw-justify-center tw-w-full tw-py-6 tw-px-6 sm:tw-py-20 tw-gap-3 sm:tw-gap-28 tw-max-w-footer tw-m-auto">
        {columns.map((props, i) => (
          <div key={props?._meta?.deliveryId ?? i} data-testid={props?._meta?.deliveryId}>
            {!(props as ImageProps)?.image && <ToutContent {...props} />}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FlexContainer;
